<template>
  <div>
    <GenericModal
      v-if="modalStatus"
      @close="errorModalClose()"
      :width="viewallModalDim.width"
      :animationStyle="viewallModalDim.animationStyle"
      :class="viewallModalDim.modalClass"
      :overflowNotNeeded="'0'"
      :contentScroll="1"
      :padding="'16px 0px 0px 0px'"
      :maxHeight="viewallModalDim.height"
      :headerWidth="'auto'"
      :height="'auto'"
    >
      <template v-slot:header>
        <div class="fs-18 bold pl16 pr16 tc color-error">
          {{ modalContent?.headerText || "" }}
        </div>
      </template>
      <template v-slot:body>
        <div
          class="modal-pop-content flex-row justify-content-center align-items-center pl10 pr10 pt16 pb16"
        >
          <div class="fs-14 tc">{{ modalContent?.message || "" }}</div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex-row justify-content-center align-item-center m8">
          <button
            class="line-btn sm repeat-btn secondary w100 br8"
            @click="errorModalClose()"
          >
            {{ modalContent?.rightCTAText || "" }}
          </button>
        </div>
      </template>
    </GenericModal>
  </div>
</template>

<script>
import utility from "../../../helpers/utility";
import GenericModal from "../../GenericModal.vue";
export default {
  name: "CustomErrorModal",
  props: ["headerMsg", "bodyMsg", "buttonMsg"],
  components: { GenericModal },
  data() {
    return {
      viewallModalDim: {
        width: "320px",
        height: "232px",
        animationStyle: "",
        modalClass: "error-modal",
      },
      errorModalOpen: true,
    };
  },
  methods: {
    errorModalClose() {
      this.$store.commit("ErrorModal/updateErrorModalOpen", false);
      this.$emit("okClick");
      if (this.modalContent?.handleClick == "login") {
        utility.sendToLoginScreen();
      }
    },
    triggerViewallModal() {
      this.$store.commit("ErrorModal/updateErrorModalOpen", true);
    },
  },
  computed: {
    modalStatus() {
      return this.$store.state.ErrorModal.errorModalOpen;
    },
    modalContent() {
      return this.$store.state.ErrorModal.content;
    },
  },
};
</script>

<style></style>
